import React, { useState, useEffect} from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";   
import CommonAPI from '../../Common/CommonAPI';
import moment from 'moment';
import SuccessMSG from "../../Common/SuccessMsg"


function  RemoveStoRecipient (props){    

  const [STORecipientList,setSTORecipientList] = useState([]);
  const [StandAccountID,setStandAccountID] = useState();
  const [StandBeneName,setStandBeneName] = useState();
  const [StandBankAccount,setStandBankAccount] = useState();
  const [StandAmount,setStandAmount] = useState();
  const [StandBeneBankName,setStandBeneBankName] = useState();
  const [StandbeneBankBranchName,setStandbeneBankBranchName] = useState();
  const [StandStartDate,setStandStartDate] = useState();
  const [Password,setPassword] = useState();
  const [ErrorMSG,setErrorMSG] = useState();
  const [SuccessRemove,setSuccessRemove] = useState(false);
   
  const GetSTORecipientAPI = () =>{
    CommonAPI.GetExistSTORecipeientsAPI((results) =>{   
        if(results){                    
          setSTORecipientList(results);
        }            
    });
  }
  useEffect( () => {
    GetSTORecipientAPI();     
  },[])  ;

 const SelectStandRecipientList = (event) => {
    var passValFrom = JSON.parse(event.target.value);     
       setStandAccountID(passValFrom.id);
       setStandBeneName(passValFrom.beneName);
       setStandBankAccount(passValFrom.bankAccNo);
       setStandAmount(passValFrom.amount);
       setStandBeneBankName(passValFrom.beneBankName);
       setStandbeneBankBranchName(passValFrom.beneBrachName);
       setStandStartDate(passValFrom.startDate);    
 }

 const CheckPassword = () =>{  
  if(!StandAccountID) {
      setErrorMSG("Select a Recipient");
  }else{
  CommonAPI.CheckPassword({password:Password},(results) =>{ 
   if(results.password==="true"){
       setErrorMSG();
       RemoveStandRecipient();
   }else{
       setErrorMSG("Enter Correct Password");
   }
  })
}
}

const RemoveStandRecipient = () =>{
  CommonAPI.RemoveSTORecipeientAPI({StandAccountID:StandAccountID},(results) =>{ 
    if(results.message ==='Success'){
        setErrorMSG();
        setSuccessRemove(true);
        setStandAccountID("");
        setSTORecipientList([]);
        GetSTORecipientAPI();        
    }else{
        setErrorMSG("Recipient Remove Unsuccess");
    }
   })
 }

        if(SuccessRemove){
          return(
          <SuccessMSG ConfirmSuccess={SuccessRemove} onHide={()=>setSuccessRemove(false)} 
          Close={()=>setSuccessRemove(false)} head="SUCCESSFULLY" head2="REMOVED" 
          contentline1="Successfully Removed Your Recipient"
          />)
        }
        return (
            <Modal
              show={props.isOpen}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>MAINTAIN</p><br/>STANDING ORDER RECIPIENT
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                            Recipient
                        </Form.Label>
                        <Col sm={7}>

                        <Form.Select size="sm" 
                        className="form-h2 "
                        onChange = {SelectStandRecipientList}
                        >
                        <option value={JSON.stringify("select")}>Select</option>
                          {STORecipientList?STORecipientList.map((listValue,index)=>{
                              return (
                              <option  key={index} value={JSON.stringify(listValue)}>
                              Account Number : {listValue.bankAccNo} |Bank : {listValue.beneBankName} | {listValue.beneName}
                              </option>)
                          }):
                          null
                          }   
                        </Form.Select>
                        </Col>
                    </Form.Group>
                    {StandAccountID?
                    <div>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                            Beneficiary Name
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                          {StandBeneName}
                        </Form.Label>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          Beneficiary Account
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                          {StandBankAccount}
                        </Form.Label>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                          Bank Name
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                            {StandBeneBankName}
                        </Form.Label>
                    </Form.Group>
                   
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={5}>
                           Branch Name
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                           {StandbeneBankBranchName}
                        </Form.Label>
                    </Form.Group>
                    
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        Start Date
                        </Form.Label>
                        <Form.Label className="c-font" column sm={7}>
                            {moment(StandStartDate).format("DD/MM/YYYY")}
                        </Form.Label>
                    </Form.Group>
                    </div>
                    :null
                    }
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={5}>
                        Password
                        </Form.Label>
                        <Col sm={7} >
                        <Form.Control 
                            maxLength={8}
                            value={Password}
                            onChange={(text)=>setPassword(text.target.value)}
                            className={!Password?"form-h2 password-f":"form-h2"} size="sm" type="password" placeholder="Password" />
                        </Col>
                    </Form.Group>
                    <p className='vali-txt'>{ErrorMSG}</p>
                    
                </Form>
              </Modal.Body>
              <Modal.Footer className="mb-1 margintop-f2">    
                <Button className="btn-logout rm-btn"
                 onClick={()=>CheckPassword()}>REMOVE</Button> 
              </Modal.Footer>
            </Modal>
          );
    }

export default RemoveStoRecipient;